import { Map } from "immutable"

import {
    STAKEHOLDER_LIST_REQUEST as LIST_REQUEST,
    STAKEHOLDER_LIST_RESPONSE as LIST_RESPONSE,
    STAKEHOLDER_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    STAKEHOLDER_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    STAKEHOLDER_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    name: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_SAVE_RESPONSE
    },
    defaultSearchCriteria
)
